export { default as OTMQuiz } from "./otm-quiz";
export { default as OTMResults } from "./otm-result";
export { default as OTMUniversities } from "./otm-universities";
